import { inheritsLoose as _inheritsLoose, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef, useEffect } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import Button from '@piconetworks/pkg-boutton';
import SocialLoginButton from '@piconetworks/pkg-social-login-button';
import { getSvgImage } from '@piconetworks/pkg-functions';
import Form from '@piconetworks/pkg-form';
import { PICO_API_URL } from '@piconetworks/pkg-endpoints';
import style from './scss/SocialLogin.module.scss.js';

var _excluded = ["fieldContainerProps", "description", "required", "onLogin", "publisherId", "userId", "origin", "referer", "params", "access_token", "isLoggedIn", "disabled", "previewMode", "authenticationMethods", "handleClick", "selected", "linkColor", "onFailure"];
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    console.log('getDerivedStateFromError', error);
    return {
      hasError: true
    };
  };
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    console.error(error.message, errorInfo);
  };
  _proto.render = function render() {
    var hasError = this.state.hasError;
    var _this$props = this.props,
      children = _this$props.children,
      _this$props$RenderErr = _this$props.RenderError,
      RenderError = _this$props$RenderErr === void 0 ? function () {
        return /*#__PURE__*/React.createElement("div", {
          className: "errorBoundaree"
        });
      } : _this$props$RenderErr;
    if (hasError) {
      return /*#__PURE__*/React.createElement(RenderError, null);
    }
    return children;
  };
  return ErrorBoundary;
}(React.Component);
var showSocialLogin = function showSocialLogin(_ref) {
  var auth_providers = _ref.auth_providers,
    provider = _ref.provider,
    params = _ref.params,
    origin = _ref.origin,
    referer = _ref.referer,
    access_token = _ref.access_token,
    publisherId = _ref.publisherId,
    userId = _ref.userId,
    onLogin = _ref.onLogin,
    disabled = _ref.disabled,
    _ref$previewMode = _ref.previewMode,
    previewMode = _ref$previewMode === void 0 ? false : _ref$previewMode,
    handleClick = _ref.handleClick,
    selected = _ref.selected,
    linkColor = _ref.linkColor,
    onFailure = _ref.onFailure;
  var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  var text;
  switch (provider) {
    case 'linkedin':
      text = 'LinkedIn';
      break;
    case 'github':
      text = 'GitHub';
      break;
    case 'twitter':
      text = 'X';
      break;
    default:
      text = capitalizeFirstLetter(provider);
      break;
  }
  var buttonElement = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.text)
  }, text), /*#__PURE__*/React.createElement("div", {
    className: classNames(style.socialIcon, style[provider])
  }, getSvgImage(null, provider + "-icon")));
  if (auth_providers.includes(provider)) {
    var isSelected = selected === text;
    return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(SocialLoginButton, {
      type: provider === 'linkedin' ? 'linkedin2' : provider,
      api_url: PICO_API_URL(),
      access_token: access_token,
      publisherId: publisherId,
      origin: origin,
      referer: referer,
      params: params,
      scope: "user",
      userId: userId,
      onLogin: !previewMode ? function (response) {
        return onLogin(response, {
          social_type: provider
        });
      } : null,
      previewMode: previewMode,
      button: /*#__PURE__*/React.createElement(Button, {
        className: classNames(style.socialButton, style[provider]),
        style: isSelected ? {
          border: "2px solid " + linkColor
        } : {},
        buttonType: "icon",
        type: "button",
        disabled: disabled,
        onClick: previewMode ? function () {
          return handleClick(text);
        } : undefined
      }, buttonElement),
      onFailure: onFailure
    }));
  } else {
    return null;
  }
};
var SocialLogin = function SocialLogin(_ref2) {
  if (_ref2 === void 0) {
    _ref2 = {};
  }
  var _ref3 = _ref2,
    fieldContainerProps = _ref3.fieldContainerProps;
    _ref3.description;
    var required = _ref3.required,
    onLogin = _ref3.onLogin,
    publisherId = _ref3.publisherId,
    userId = _ref3.userId,
    origin = _ref3.origin,
    referer = _ref3.referer,
    params = _ref3.params,
    access_token = _ref3.access_token,
    isLoggedIn = _ref3.isLoggedIn,
    disabled = _ref3.disabled,
    previewMode = _ref3.previewMode,
    _ref3$authenticationM = _ref3.authenticationMethods,
    authenticationMethods = _ref3$authenticationM === void 0 ? [] : _ref3$authenticationM,
    _ref3$handleClick = _ref3.handleClick,
    handleClick = _ref3$handleClick === void 0 ? function () {} : _ref3$handleClick,
    _ref3$selected = _ref3.selected,
    selected = _ref3$selected === void 0 ? 'all' : _ref3$selected,
    linkColor = _ref3.linkColor,
    onFailure = _ref3.onFailure,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded);
  var socialLoginRef = useRef(null);
  useEffect(function () {
    if (isLoggedIn) {
      var _socialLoginRef$curre;
      (_socialLoginRef$curre = socialLoginRef.current) === null || _socialLoginRef$curre === void 0 ? void 0 : _socialLoginRef$curre.click();
    }
  }, [isLoggedIn]);
  var socialProps = {
    params: params,
    origin: origin,
    referer: referer,
    publisherId: publisherId,
    userId: userId,
    access_token: access_token,
    onLogin: onLogin,
    disabled: disabled,
    previewMode: previewMode,
    handleClick: handleClick,
    selected: selected,
    linkColor: linkColor,
    onFailure: onFailure
  };
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Form.Field, fieldContainerProps, /*#__PURE__*/React.createElement("div", {
    className: style.socialLogin
  }, authenticationMethods.includes('apple') && showSocialLogin(Object.assign({
    auth_providers: ['apple'],
    provider: 'apple'
  }, socialProps)), authenticationMethods.includes('facebook') && showSocialLogin(Object.assign({
    auth_providers: ['facebook'],
    provider: 'facebook'
  }, socialProps)), authenticationMethods.includes('github') && showSocialLogin(Object.assign({
    auth_providers: ['github'],
    provider: 'github'
  }, socialProps)), authenticationMethods.includes('google') && showSocialLogin(Object.assign({
    auth_providers: ['google'],
    provider: 'google'
  }, socialProps)), authenticationMethods.includes('linkedin') && showSocialLogin(Object.assign({
    auth_providers: ['linkedin'],
    provider: 'linkedin'
  }, socialProps)), authenticationMethods.includes('twitch') && showSocialLogin(Object.assign({
    auth_providers: ['twitch'],
    provider: 'twitch'
  }, socialProps)), authenticationMethods.includes('twitter') && showSocialLogin(Object.assign({
    auth_providers: ['twitter'],
    provider: 'twitter'
  }, socialProps))), /*#__PURE__*/React.createElement(Field, _extends({
    ref: socialLoginRef,
    component: Form.Input,
    type: "submit"
  }, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, rest, {
    style: {
      display: 'none'
    }
  }))));
};
SocialLogin.displayName = 'FieldSocialLogin';

export { SocialLogin as default };
//# sourceMappingURL=index.js.map
